<h1 mat-dialog-title class="text-center pm-dialog-title">
  {{ isBatch ? ('Language.BatchAddPopupText' | translate) : ('Language.SerialAddPopupText' | translate)}}
</h1>
<div mat-dialog-content class="contentt">
    <div class="row mb-2">
        <div class="col-3">
          <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="ItemCode" 
              [ngModel]="this.local_data.itemCode" readonly="true" 
              placeholder="Item Code">
          </mat-form-field>
        </div>
        <div class="col-3">
          <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="WarehouseName" 
              [ngModel]="this.local_data.warehouseName" readonly="true" 
              placeholder="Warehouse Name">
          </mat-form-field>
        </div>
        <div class="col-3">
          <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="quantity" 
              [ngModel]="this.local_data.quantity" readonly="true" 
              placeholder="Quantity">
          </mat-form-field>
        </div>
        <div class="col-3">
            <div class="text-end">
                <button mat-raised-button color="primary" (click)="addItemRow()"
                [disabled]="this.local_data.isViewMode">
                  <mat-icon>add</mat-icon>
                  {{'Language.AddText' | translate}}
                </button>
            </div>
        </div>
    </div>
    <div class="tabledesign" *ngIf="isBatch">
      <table mat-table  class="mat-elevation-z8" [dataSource]="this.batchItemRows">
        <ng-container matColumnDef="serialNo">
          <th mat-header-cell *matHeaderCellDef style="position: sticky;z-index:100;">
            {{'Language.S.No.Text' | translate}}
          </th>
          <td *matCellDef="let element; let i = index">
            <div class="text-center">
                {{i + 1}}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="BatchNo">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.BatchNumberText' | translate}}
          </th>
          <td mat-cell *matCellDef="let element; let i = index;">
            <mat-form-field class="field-bottom-0" appearance="outline">
                <input type="text" matInput [name]="'batchNo'+ i" 
               (input)="syncBatchNumber(element)"
                [(ngModel)]="element.batchNumberProperty" 
                
                [disabled]="this.local_data.isViewMode"
                placeholder="Batch Number">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="Quantity">
          <th mat-header-cell *matHeaderCellDef>
           {{'Language.QuantityText' | translate}}  
          </th>
          <td mat-cell *matCellDef="let element; let i = index;">
            <mat-form-field class="field-bottom-0" appearance="outline">
                <input type="number" matInput [name]="'qty' + i" 
                [disabled]="this.local_data.isViewMode"
                [(ngModel)]="element.quantity" #qtyEl
                (input)="enterQuantity(qtyEl,i)"
                placeholder="Quantity">
            </mat-form-field>
        </td>
        </ng-container>
        <ng-container matColumnDef="BatchAttribute1">
            <th mat-header-cell *matHeaderCellDef>
              {{'Language.BatchAtt1Text' | translate}}   
            </th>
            <td mat-cell *matCellDef="let element; let i = index;">
                <mat-form-field class="field-bottom-0" appearance="outline">
                    <input type="text" matInput [name]="'InternalSerialNumber' + i" 
                    [disabled]="this.local_data.isViewMode"
                    [(ngModel)]="element.internalSerialNumber" 
                    placeholder="Batch Attribute 1">
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="BatchAttribute2">
            <th mat-header-cell *matHeaderCellDef>
              {{'Language.BatchAtt2Text' | translate}} 
            </th>
            <td mat-cell *matCellDef="let element; let i = index;">
                <mat-form-field class="field-bottom-0" appearance="outline">
                    <input type="text" matInput [name]="'batchAttribute2' + i" 
                    [disabled]="this.local_data.isViewMode"
                    [(ngModel)]="element.manufacturerSerialNumber" 
                    placeholder="Batch Attribute 2">
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="BinLocationAllocation">
          <th mat-header-cell *matHeaderCellDef hidden>
           {{'Language.BinLocationAllocationText' | translate}} 
          </th>
          <td mat-cell *matCellDef="let element; let i = index;" hidden>
            <mat-form-field class="field-bottom-0" appearance="outline">
                <input type="text" matInput [name]="'BinLocationAllocation' + i" 
                [disabled]="this.local_data.isViewMode"
                [(ngModel)]="element.binLocationValue" readonly="true" 
                placeholder="Bin Location Allocation">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="ExpirationDate">
            <th mat-header-cell *matHeaderCellDef>
              {{'Language.ExpirationDateText' | translate}}
            </th>
            <td mat-cell *matCellDef="let element; let i = index;">
              <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                  <input [matDatepicker]="ExpiraitonDate" required type="text" [(ngModel)]="element.expiryDate"
                      matInput readonly (click)="ExpiraitonDate.open()" [name]="'ExpiraitonDate' + i"
                      [disabled]="this.local_data.isViewMode"
                      placeholder="Expiration Date" />
                  <mat-datepicker-toggle matSuffix [for]="ExpiraitonDate">
                  </mat-datepicker-toggle>
                  <mat-datepicker #ExpiraitonDate>
                  </mat-datepicker>
              </mat-form-field>
            </td>
          </ng-container>
        <ng-container matColumnDef="MfrDate">
          <th mat-header-cell *matHeaderCellDef>
          {{'Language.MfrDateText' | translate}}  
          </th>
          <td mat-cell *matCellDef="let element; let i = index;">
            <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                <input [matDatepicker]="ManufacturingDate" required type="text" [(ngModel)]="element.manufacturingDate"
                    matInput readonly (click)="ManufacturingDate.open()" [name]="'ManufacturingDate' + i"
                    [disabled]="this.local_data.isViewMode"
                    placeholder="Manufacturing Date" />
                <mat-datepicker-toggle matSuffix [for]="ManufacturingDate">
                </mat-datepicker-toggle>
                <mat-datepicker #ManufacturingDate>
                </mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="AdmissionDate">
            <th mat-header-cell *matHeaderCellDef>
             {{'Language.AdmissionDateText' | translate}}
            </th>
            <td mat-cell *matCellDef="let element; let i = index;">
              <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                  <input [matDatepicker]="AddmisionDate" required type="text" [(ngModel)]="element.addmisionDate"
                      matInput readonly (click)="AddmisionDate.open()" [name]="'AddmisionDate' + i"
                      [disabled]="this.local_data.isViewMode"
                      placeholder="Admission Date" />
                  <mat-datepicker-toggle matSuffix [for]="AddmisionDate">
                  </mat-datepicker-toggle>
                  <mat-datepicker #AddmisionDate>
                  </mat-datepicker>
              </mat-form-field>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="this.batchDisplayedColumns;sticky:true"></tr>
        <tr mat-row *matRowDef="let row; columns: this.batchDisplayedColumns;"></tr>
      </table>
    </div>
    <div class="tabledesign" *ngIf="!isBatch">
      <table mat-table  class="mat-elevation-z8" [dataSource]="this.serialItemRows">
        <ng-container matColumnDef="serialNo">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.S.No.Text' | translate }}
          </th>
          <td *matCellDef="let element; let i = index">
            <div class="text-center">
                {{i + 1}}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="ManufSerialNumber">
            <th mat-header-cell *matHeaderCellDef>
              {{'Language.ManufacturingSerialNoText' | translate }} 
            </th>
            <td mat-cell *matCellDef="let element; let i = index;">
                <mat-form-field class="field-bottom-0" appearance="outline">
                    <input type="text" matInput [name]="'ManufSerialNumber' + i" 
                    [disabled]="this.local_data.isViewMode"
                    [(ngModel)]="element.manufacturerSerialNumber"
                    placeholder="Mfr Serial No.">
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="InteSerialNumber">
            <th mat-header-cell *matHeaderCellDef>
             {{'Language.SerialNoText'| translate}}
            </th>
            <td mat-cell *matCellDef="let element; let i = index;">
                <mat-form-field class="field-bottom-0" appearance="outline">
                    <input type="text" matInput [name]="'InteSerialNumber' + i" 
                    [disabled]="this.local_data.isViewMode"
                    [(ngModel)]="element.internalSerialNumber"
                    placeholder="Serial Number">
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="lotNum">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.LotNumberText' | translate}}
          </th>
          <td mat-cell *matCellDef="let element; let i = index;">
              <mat-form-field class="field-bottom-0" appearance="outline">
                  <input type="text" matInput [name]="'lotNum' + i" 
                  [disabled]="this.local_data.isViewMode"
                  [(ngModel)]="element.batchID"
                  placeholder="Lot Number">
              </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="binLocation">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.BinLocationAllocationText' | translate}}
          </th>
          <td mat-cell *matCellDef="let element; let i = index;">
            <mat-form-field class="field-bottom-0" appearance="outline">
                <input type="text" matInput [name]="'BinLocationAllocation' + i" 
                [disabled]="this.local_data.isViewMode"
                [(ngModel)]="element.binLocationValue" readonly="true"
                placeholder="Bin Location Allocation">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="Expirydate">
            <th mat-header-cell *matHeaderCellDef>
              {{'Language.ExpirationDateText' | translate}}
            </th>
            <td mat-cell *matCellDef="let element; let i = index;">
              <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                  <input [matDatepicker]="ExpiraitonDate" required type="text" [(ngModel)]="element.expiryDate"
                  [disabled]="this.local_data.isViewMode"
                      matInput readonly (click)="ExpiraitonDate.open()" [name]="'ExpiraitonDate' + i"
                      placeholder="Expiration Date" />
                  <mat-datepicker-toggle matSuffix [for]="ExpiraitonDate">
                  </mat-datepicker-toggle>
                  <mat-datepicker #ExpiraitonDate>
                  </mat-datepicker>
              </mat-form-field>
            </td>
          </ng-container>
        <ng-container matColumnDef="manufDate">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.ManufacturingDateText' | translate}}
          </th>
          <td mat-cell *matCellDef="let element; let i = index;">
            <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                <input [matDatepicker]="ManufacturingDate" required type="text" [(ngModel)]="element.manufactureDate"
                    matInput readonly (click)="ManufacturingDate.open()" [name]="'ManufacturingDate' + i"
                    [disabled]="this.local_data.isViewMode"
                    placeholder="Manufacturing Date" />
                <mat-datepicker-toggle matSuffix [for]="ManufacturingDate">
                </mat-datepicker-toggle>
                <mat-datepicker #ManufacturingDate>
                </mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="admDate">
            <th mat-header-cell *matHeaderCellDef>
              {{'Language.ReceptionDateText' | translate}}
            </th>
            <td mat-cell *matCellDef="let element; let i = index;">
              <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                  <input [matDatepicker]="AddmisionDate" required type="text" [(ngModel)]="element.receptionDate"
                      matInput readonly (click)="AddmisionDate.open()" [name]="'AddmisionDate' + i"
                      [disabled]="this.local_data.isViewMode"
                      placeholder="Admission Date" />
                  <mat-datepicker-toggle matSuffix [for]="AddmisionDate">
                  </mat-datepicker-toggle>
                  <mat-datepicker #AddmisionDate>
                  </mat-datepicker>
              </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="warrantyStart">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.MfrWarrantyStartText' | translate}}
          </th>
          <td mat-cell *matCellDef="let element; let i = index;">
            <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                <input [matDatepicker]="warrantyStart" required type="text" [(ngModel)]="element.warrantyStart"
                    matInput readonly (click)="warrantyStart.open()" [name]="'warrantyStart' + i"
                    [disabled]="this.local_data.isViewMode"
                    placeholder="Warranty Start" />
                <mat-datepicker-toggle matSuffix [for]="warrantyStart">
                </mat-datepicker-toggle>
                <mat-datepicker #warrantyStart>
                </mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="warrantyEnd">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.MfrWarrantyEndText' | translate}}
          </th>
          <td mat-cell *matCellDef="let element; let i = index;">
            <mat-form-field appearance="outline" class="w-100 field-bottom-0">
                <input [matDatepicker]="warrantyEnd" required type="text" [(ngModel)]="element.warrantyEnd"
                    matInput readonly (click)="warrantyEnd.open()" [name]="'warrantyEnd' + i"
                    [disabled]="this.local_data.isViewMode"
                    placeholder="Warranty End" />
                <mat-datepicker-toggle matSuffix [for]="warrantyEnd">
                </mat-datepicker-toggle>
                <mat-datepicker #warrantyEnd>
                </mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="SysNumber">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.SysNumberText' | translate}}    
          </th>
          <td mat-cell *matCellDef="let element; let i = index;">
            <mat-form-field class="field-bottom-0" appearance="outline">
                <input type="text" matInput [name]="'SysNumber' + i" 
                [(ngModel)]="element.systemSerialNumber" 
                [disabled]="this.local_data.isViewMode"
                placeholder="Sys Number" readonly="true">
            </mat-form-field>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="this.serialDisplayedColumns;sticky:true"></tr>
        <tr mat-row *matRowDef="let row; columns: this.serialDisplayedColumns;"></tr>
      </table>
    </div>
</div>
<div class="d-flex justify-content-between">
    <div mat-dialog-actions align="start" class="ps-4">
        <button mat-raised-button color="primary" (click)="showAutoRowCreationPopup()"
        [disabled]="this.local_data.isViewMode"> 
          <mat-icon>edit</mat-icon>
          {{'Language.AutoCreationText' | translate}}  
        </button>
    </div>
    <div mat-dialog-actions align="end">
        <button mat-raised-button color="primary" (click)="addBatchSerial()" [disabled]="this.local_data.isViewMode">
          {{'Language.AddText' | translate}}  
        </button>
        <button mat-raised-button mat-dialog-close>{{'Language.CancelText' | translate}}  </button>
    </div>
</div>